// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"3ca3d318","586":"b5f77380","589":"2a593664"}[chunkId] + ".chunk.css";
};